import React from "react";

export default function ErrorPage() {
  return <div>Something went wrong...</div>;
}
